export default __webpack_public_path__ + "static/media/GBLB_Logo_Mark_FullColor.4e770652.png";